/* global axios */
import ApiClient from './ApiClient';

class WhatsappContactCardsAPI extends ApiClient {
  constructor() {
    super('whatsapp_qr', { accountScoped: true });
  }

  send(conversationId, cards) {
    return axios.post(
      `${this.url}/conversations/${conversationId}/contact_cards`,
      {
        cards,
      }
    );
  }

  save(messageId, cardIndex, phoneIndex) {
    return axios.post(`${this.url}/messages/${messageId}/contact_cards/save`, {
      card_index: cardIndex,
      phone_index: phoneIndex,
    });
  }
}

export default new WhatsappContactCardsAPI();
